import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsocketService } from 'shared';
import { INotificationDetails } from '../../model/ticket.model';
import { Router } from '@angular/router';
import { TicketService } from '../../services/ticket.service';

@Component({
  selector: 'myt-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrl: './notifications-list.component.scss',
  standalone: false,
})
export class NotificationsListComponent implements OnInit, OnDestroy {
  notifications: any[] = [];
  private notificationSubscription: Subscription[] = [];

  constructor(
    private websocketService: WebsocketService,
    private router: Router,
    private ticketService: TicketService
  ) {}

   ngOnInit(): void {
  //   // this.ticketService.getNotification({}).subscribe((result) => {
  //   //   if (result.status === 'Success') {
  //   //     this.notifications = result.data.resultList;
  //   //   }
  //   // });
  //   this.websocketService.connect();
  //   this.notificationSubscription.push(
  //     this.websocketService.getOwnNotifications().subscribe((result) => {
  //       this.notifications.push(result.body);
  //       console.log('Notification received: ', result.body);
  //     })
  //   );
  //   this.notificationSubscription.push(
  //     this.websocketService.getAllNotifications().subscribe((result) => {
  //       this.notifications.push(result.body);
  //       console.log('Notification received: ', result.body);
  //     })
  //   );
   }

  ngOnDestroy(): void {
    this.websocketService.disconnect();
    if (this.notificationSubscription) {
      this.notificationSubscription.forEach((item) => item.unsubscribe());
    }
  }

  openNotification(notificationData: INotificationDetails, index: number) {
    switch (notificationData.type) {
      case 'TICKET':
        this.router.navigate([
          '/user',
          'ticket',
          'details',
          notificationData.entityId,
        ]);
        break;

      default:
        break;
    }
  }
}
